// extracted by mini-css-extract-plugin
module.exports = {"withCookieBanner":"src_withCookieBanner__3NzZE","rebrandBody":"src_rebrandBody__3whOp"};